<dashboardnav>

    <cradua-requestsubcategory
    [requestcategorys]="requestcategorys$ | async"
    [requestsubcategorys]="requestsubcategorys$ | async"
  
    (changeEmit)="onSubmitRequestSubCategory($event)"
    (deleteEvent)="onDeleteRequestSubCategory($event)"
    *ngIf="
    !(isLoadingRequestCategory$ | async ) &&
    !(isLoadingRequestSubCategory$ | async )
    "
    >
  </cradua-requestsubcategory>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="
    (isLoadingRequestCategory$ | async ) ||
    (isLoadingRequestSubCategory$ | async )
    "
  >
    </mrsoftapps-epims-reference-spinner>
  </dashboardnav>
  